import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';

export interface SortableDragHandleProps {
    attributes: DraggableAttributes;
    listeners: DraggableSyntheticListeners;
}

const SortableDragHandle = ({ attributes, listeners }: SortableDragHandleProps) => (
    <button
        type="button"
        className="btn btn-link p-0 border-0 text-muted drag-handle"
        aria-label="Reorder"
        {...attributes}
        {...listeners}
    >
        <i className="bi bi-grip-vertical" />
    </button>
);

export default SortableDragHandle;
